export default __webpack_public_path__ + "static/media/Bit.2097ccb2.jpg";